import { useState, createContext, useContext } from "react";
import { toast } from "react-toastify";

import { appConfig } from "../config/appConfig.js";

const CatalogContext = createContext();

export const CatalogContextProvider = ({ children }) => {
  const serverBaseUrl = `${appConfig.serverBaseUrl}/api/${appConfig.serverApiVersion}/${appConfig.dataSource}`;
  const sortingParameter = `?sort=item_code`;

  const [isLoading, setIsLoading] = useState(false);
  const [hasWatermark, setHasWatermark] = useState(true);

  const [brandInfo, setBrandInfo] = useState({});
  const [activeTables, setActiveTables] = useState({});
  const [selectedTable, setSelectedTable] = useState({});
  const [selectedTableData, setSelectedTableData] = useState({});

  const getBrandInfo = async () => {
    setIsLoading(true);
    fetch(`${serverBaseUrl}/brandInfo`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((response) => {
        if (!response?.success) {
          toast.error(response?.message);
        } else {
          setBrandInfo(response?.data);
        }
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        toast.error("Unable to fetch brand info");
      });
  };

  const getAllActiveTables = async () => {
    setIsLoading(true);
    fetch(`${serverBaseUrl}/tables`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((response) => {
        if (!response?.success) {
          toast.error(response?.message);
        } else {
          setActiveTables(response?.data);
        }
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        toast.error("Unable to fetch active tables");
      });
  };

  const getSelectedTableData = async (tableName) => {
    setIsLoading(true);
    fetch(
      `${serverBaseUrl}/tables/${tableName}/records${sortingParameter || ""}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    )
      .then((res) => res.json())
      .then((response) => {
        if (!response?.success) {
          toast.error(response?.message);
        } else {
          setSelectedTableData(response?.data);
        }
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        toast.error("Unable to fetch table data");
      });
  };

  return (
    <CatalogContext.Provider
      value={{
        isLoading,
        hasWatermark,
        brandInfo,
        activeTables,
        selectedTableData,
        selectedTable,
        setHasWatermark,
        setSelectedTable,
        getBrandInfo,
        getAllActiveTables,
        getSelectedTableData,
      }}
    >
      {children}
    </CatalogContext.Provider>
  );
};

export const useCatalogContext = () => useContext(CatalogContext);
